import { render } from "./rispSummary.vue?vue&type=template&id=06d374b8&scoped=true"
import script from "./rispSummary.vue?vue&type=script&lang=js"
export * from "./rispSummary.vue?vue&type=script&lang=js"

import "./rispSummary.vue?vue&type=style&index=0&id=06d374b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d374b8"]])

export default __exports__